import React from 'react'
import Nav from '../Nav/nav';
import Left from '../TentangKami/picture/container-left.png';
import Right from '../TentangKami/picture/container-right.jpg';
import './TentangKami.css'

const TentangKami = () => {
    return (
        <div>
            <Nav />
            <div className="tentangkami">
                <div className="container-tentangkami">
                    <div className="container-top">
                        <div className="text-top">
                            <h1>Apa itu <span className="text-top-weshare">WeShare</span>?</h1>
                            <p className="text-top-p1">Sebuah situs galang dana dan donasi online yang didirikan oleh
                                Zulfikar Ilham Ramadhan sebagai penghubung antara pendonasi untuk
                                membantu mereka yang membutuhkan.
                            </p>
                            <p>Berdiri sejak tahun 2021 serta mendapatkan izin dari Kementerian
                                Sosial dan Kementerian Komunikasi dan Informasi, WeShare
                                dipercaya jutaan masyarakat dan berbagai perusahaan sebagai
                                jembatan kebaikan.
                            </p>
                        </div>
                        <div className="gambar">
                            <img className="gambar-top" src={Left} />
                        </div>
                    </div>

                    <div className="container-bottom">

                        <div className="gambar">
                            <img className="gambar-bottom" src={Right} />
                        </div>

                        <div className="text-bottom">
                            <h1>Program CSR yang Kami Jalankan</h1>
                            <p className="text-top-p1">Supaya jembatan ini semakin kuat, kolaborasi adalah kunci
                                agar kebaikan terus tersalurkan. Sudah lebih dari 40
                                perusahaan yang bekerja sama dengan WeShare dan banyak
                                #TemanKita mendapatkan bantuan.
                            </p>

                            {/* <p>
                                Apa saja yang bisa WeShare tawarkan?
                            </p> */}
                        </div>

                    </div>

                </div>

                <div className="container-item">
                    <h1>Kenapa Donasi di <span className="text-top-weshare">WeShare</span> ?</h1>
                    <div className="container-bot">

                        <div className="item-1">
                            <h1>Aman dan Terpercaya</h1>
                            <p>Semua galang dana yang dibuat sudah
                                melalui proses kurasi dan verifikasi secara
                                akurat oleh tim kami
                            </p>
                        </div>
                        <div className="item-2">
                            <h1>Mudah dan Cepat</h1>
                            <p>Proses donasi yang kamu lakukan hanya
                                dalam hitungan menit dengan berbagai
                                metode pembayaran
                            </p>
                        </div>
                        <div className="item-3">
                            <h1>Transparan</h1>
                            <p>Pencairan dan penggunaan donasi yang
                                sudah diterima penggalang dana dapat
                                dilihat di update aktivitas
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TentangKami;
